export const OLD_TAX_DOCUMENTS_PATH = "/member/tax-documents/2023";
export const OLD_TAX_DOCUMENTS_DETAILS_PATH =
  OLD_TAX_DOCUMENTS_PATH + "/:taxFormId";
export const OLD_TAX_DOCUMENTS_PREFERENCES_PATH =
  OLD_TAX_DOCUMENTS_PATH + "/tax-preferences";
export const OLD_TAX_DOCUMENTS_REQUEST_CORRECTION_PATH =
  OLD_TAX_DOCUMENTS_DETAILS_PATH + "/request-correction";
